import { getElements } from 'js-utils/src/selector';
import { addClass, removeClass } from 'js-utils/src/attribute';

import init from '../../common/base/init';

init(() => {
  const quiz = document.querySelector('.quiz');
  if(!quiz) return;

  const questions = getElements('.-question', quiz);
  const questionsContainer = getElements('.-question--container', quiz);
  if(!questions.length) return;

  const container = document.querySelector('.quiz__questions__container');
  const nextQuestionTrigger = quiz.querySelector('.-next');
  const prevQuestionTrigger = quiz.querySelector('.-prev');
  const seeAnswersTrigger = quiz.querySelector('.-see-answers');
  const startOverQuizTrigger = quiz.querySelector('.-start-over');
  const questionRadios = getElements('input[type="radio"]', quiz);
  const submit = quiz.querySelector('.-submit');
  const quizID = submit.getAttribute('data-quiz-id');
  const videoID = submit.getAttribute('data-video-id');

  let currentQuestion = 0;
  let answersArray = [];

  const toggleNavigation = () => {
    if(currentQuestion === questions.length-1)
      addClass(nextQuestionTrigger, '--disabled');
    else
      removeClass(nextQuestionTrigger, '--disabled');

    if(currentQuestion === 0)
      addClass(prevQuestionTrigger, '--disabled');
    else
      removeClass(prevQuestionTrigger, '--disabled');
  };

  const nextQuestion = () => {
    if(currentQuestion >= questions.length - 1) return;
    const questionOffset = 100 / questions.length;
    removeClass(nextQuestionTrigger, '--disabled');
    currentQuestion++;
    container.style.transform = `translateX(-${questionOffset*currentQuestion}%)`;
    toggleNavigation();
  };

  const prevQuestion = () => {
    if(currentQuestion < 1) return;
    const questionOffset = 100 / questions.length;
    removeClass(prevQuestionTrigger, '--disabled');
    currentQuestion--;
    container.style.transform = `translateX(-${questionOffset*currentQuestion}%)`;
    toggleNavigation();
  };

  const seeAnswers = () => {
    currentQuestion = 0;
    container.style.transform = 'translateX(0%)';
    removeClass(quiz, '--disabled');
    toggleNavigation();
  };

  const startOverQuiz = () => {
    questionsContainer.forEach((question) => {
      removeClass(question, '-question--correct');
      removeClass(question, '-question--incorrect');
    });

    questionRadios.forEach((radio) => {
      radio.checked = false;
    });

    currentQuestion = 0;
    answersArray = [];
    container.style.transform = 'translateX(0%)';
    removeClass(quiz, '--disabled');
    toggleNavigation();
  };

  nextQuestionTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    nextQuestion();
  });

  prevQuestionTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    prevQuestion();
  });

  seeAnswersTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    seeAnswers();
  });

  startOverQuizTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    startOverQuiz();
  });

  questionRadios.forEach((radio) => {
    radio.addEventListener('change', function() {
      addClass(nextQuestionTrigger, '--flash');
      setTimeout(function() {
        removeClass(nextQuestionTrigger, '--flash');
      }, 1500);

      answersArray[(currentQuestion)] = {
        question_id: this.getAttribute('data-question-id'),
        option_id: this.getAttribute('data-option-id'),
      };
    });
  });

  submit.addEventListener('click', (e) => {
    e.preventDefault();

    questionsContainer.forEach((question) => {
      removeClass(question, '-question--correct');
      removeClass(question, '-question--incorrect');
    });

    fetch('/api/v1/quiz_attempts', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        quiz_id: quizID,
        video_id: videoID,
        answers: answersArray,
      }),
    })
    .then((r) => r.json())
    .then((response) => {
      addClass(quiz, '--disabled');
      questionsContainer.forEach((question) => {
        addClass(question, '-question--incorrect');
      });
      let questionsCorrectArr = response.data.attributes.correct_answers.data;
      quiz.querySelector('.js-correct-answers').innerHTML = questionsCorrectArr.length;
      for (let key in questionsCorrectArr) {
        let questionElem = quiz.querySelector('[data-question="'+ questionsCorrectArr[key].attributes.question.data.id +'"]');
        removeClass(questionElem, '-question--incorrect');
        addClass(questionElem, '-question--correct');
      }
    });
  });

  toggleNavigation();
});
